import styled from 'styled-components'

export const Wrapper = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
`
